import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Button } from '@zapier/design-system';
import { useCallback, useEffect, useRef, useState } from 'react';
import { labelStyles } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { useTracking } from '../../tracking';
const Styles = labelStyles('ShowMoreSection', {
    root: css({
        maxWidth: '1170px',
        margin: '0 auto',
    }),
    contentWrapper: (maxHeight) => css({
        margin: '0 auto',
        justifyContent: 'center',
        maxHeight,
        transition: 'all 0.25s ease',
        overflow: 'hidden',
    }),
    buttonWrapper: (isVisible) => css({
        margin: '20px',
        display: isVisible ? 'none' : 'flex',
        justifyContent: 'center',
    }),
});
export function ShowMoreSection(props) {
    const [expandedHeight, setExpandedHeight] = useState(0);
    const [isContentVisible, setIsContentVisible] = useState(false);
    const contentRef = useRef(null);
    const calculateExpandedHeight = useCallback(() => {
        if (contentRef.current) {
            setExpandedHeight(contentRef.current.scrollHeight);
        }
    }, []);
    useEffect(() => {
        calculateExpandedHeight();
        window.addEventListener('resize', calculateExpandedHeight);
        return () => window.removeEventListener('resize', calculateExpandedHeight);
    }, [calculateExpandedHeight]);
    const { emitUserInteractionEvent } = useTracking();
    const handleOnHideClick = () => {
        setIsContentVisible(false);
        emitUserInteractionEvent({
            event_action: 'click',
            interaction_name: 'hide_click',
            interaction_raw_text: props.showLessText,
            option_selected: 'hide_button',
        });
    };
    const handleOnShowClick = () => {
        setIsContentVisible(true);
        emitUserInteractionEvent({
            event_action: 'click',
            interaction_name: 'show_click',
            interaction_raw_text: props.showMoreText,
            option_selected: 'show_button',
        });
    };
    const hasOnlyShowLessBottomButton = props.hasShowLessBottomButton && !props.hasShowLessTopButton;
    return (_jsxs("div", Object.assign({ css: Styles.root }, { children: [!hasOnlyShowLessBottomButton && (_jsx("div", Object.assign({ css: Styles.buttonWrapper(isContentVisible) }, { children: _jsx(Button, Object.assign({ iconBefore: props.showMoreIcon, onClick: handleOnShowClick, color: props.color }, { children: props.showMoreText })) }))), props.hasShowLessTopButton && (_jsx("div", Object.assign({ css: Styles.buttonWrapper(!isContentVisible) }, { children: _jsx(Button, Object.assign({ iconBefore: props.showLessIcon, onClick: handleOnHideClick, color: props.color }, { children: props.showLessText })) }))), _jsx("div", Object.assign({ ref: contentRef, css: Styles.contentWrapper(isContentVisible ? expandedHeight : 0), "data-testid": "content" }, { children: props.children })), hasOnlyShowLessBottomButton && (_jsx("div", Object.assign({ css: Styles.buttonWrapper(isContentVisible) }, { children: _jsx(Button, Object.assign({ iconBefore: props.showMoreIcon, onClick: handleOnShowClick, color: props.color }, { children: props.showMoreText })) }))), props.hasShowLessBottomButton && (_jsx("div", Object.assign({ css: Styles.buttonWrapper(!isContentVisible) }, { children: _jsx(Button, Object.assign({ iconBefore: props.showLessIcon, onClick: handleOnHideClick, color: props.color }, { children: props.showLessText })) })))] })));
}
//# sourceMappingURL=ShowMoreSection.js.map